import { SwipeableDrawer, paperClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
const Root = styled(SwipeableDrawer)({
  [`.${paperClasses.root}`]: {
    padding: "22px 16px",
    maxHeight: "calc(100vh - 72px)",
    overflow: "hidden",
    borderTopLeftRadius: "16px",
    borderTopRightRadius: "16px"
  }
});
const Header = styled("div")({
  paddingBottom: "24px"
});
const ContentWrapper = styled("div")({
  flexGrow: 1,
  overflow: "auto"
});
const Action = styled("div")({
  paddingTop: "24px"
});
const Puller = styled("div")(({ theme }) => ({
  width: "32px",
  height: "4px",
  backgroundColor: theme.palette.grey[400],
  borderRadius: "8px",
  margin: "0 auto",
  minHeight: "4px",
  marginBottom: "24px"
}));
export {
  Action,
  ContentWrapper,
  Header,
  Puller,
  Root
};
